import { IAppAction } from "../appAction";
import { searchActions } from "./search-action";
import { getDefaultSearchState, ISearchState } from "./search-state";

const handlers = {
  [searchActions.GET_TRENDING_SEARCHES]: (
    state: ISearchState
  ): ISearchState => {
    return {
      ...state,
      trendingTags: {
        tags: [],
        error: null,
        loading: true
      }
    };
  },
  [searchActions.SET_TRENDING_SEARCHES_SUCCESS]: (
    state: ISearchState,
    payload: any
  ): ISearchState => {
    return {
      ...state,
      trendingTags: {
        error: null,
        loading: false,
        tags: payload
      }
    };
  },
  [searchActions.SET_TRENDING_SEARCHES_ERROR]: (
    state: ISearchState,
    payload: Error
  ): ISearchState => {
    return {
      ...state,
      trendingTags: {
        tags: [],
        loading: false,
        error: payload
      }
    };
  },
  [searchActions.GET_CREATORS_SEARCHES]: (
    state: ISearchState
  ): ISearchState => {
    return {
      ...state,
      creators: {
        error: null,
        loading: true,
        creators: []
      }
    };
  },
  [searchActions.SET_CREATORS_SEARCHES_SUCCESS]: (
    state: ISearchState,
    payload: any
  ): ISearchState => {
    return {
      ...state,
      creators: {
        error: null,
        loading: false,
        creators: payload
      }
    };
  },
  [searchActions.SET_CREATORS_SEARCHES_ERROR]: (
    state: ISearchState,
    payload: Error
  ): ISearchState => {
    return {
      ...state,
      creators: {
        creators: [],
        loading: false,
        error: payload
      }
    };
  },
  [searchActions.GET_NICHES_SEARCHES]: (
    state: ISearchState
  ): ISearchState => {
    return {
      ...state,
      niches: {
        error: null,
        loading: true,
        niches: []
      }
    };
  },
  [searchActions.SET_NICHES_SEARCHES_SUCCESS]: (
    state: ISearchState,
    payload: any
  ): ISearchState => {
    return {
      ...state,
      niches: {
        error: null,
        loading: false,
        niches: payload
      }
    };
  },
  [searchActions.SET_NICHES_SEARCHES_ERROR]: (
    state: ISearchState,
    payload: Error
  ): ISearchState => {
    return {
      ...state,
      niches: {
        niches: [],
        loading: false,
        error: payload
      }
    };
  },
  [searchActions.GET_TAGS_SEARCHES]: (
    state: ISearchState
  ): ISearchState => {
    return {
      ...state,
      tags: {
        error: null,
        tags: [],
        loading: true
      }
    };
  },
  [searchActions.SET_TAGS_SEARCHES_SUCCESS]: (
    state: ISearchState,
    payload: any
  ): ISearchState => {
    return {
      ...state,
      tags: {
        error: null,
        loading: false,
        tags: payload
      }
    };
  },
  [searchActions.SET_TAGS_SEARCHES_ERROR]: (
    state: ISearchState,
    payload: Error
  ): ISearchState => {
    return {
      ...state,
      tags: {
        tags: [],
        loading: false,
        error: payload
      }
    };
  },
  [searchActions.GET_HISTORY_SEARCHES]: (
    state: ISearchState
  ): ISearchState => {
    return {
      ...state,
      history: {
        error: null,
        history: [],
        loading: true
      }
    };
  },
  [searchActions.SET_HISTORY_SEARCHES_SUCCESS]: (
    state: ISearchState,
    payload: any
  ): ISearchState => {
    return {
      ...state,
      history: {
        error: null,
        loading: false,
        history: payload
      }
    };
  },
  [searchActions.SET_HISTORY_SEARCHES_ERROR]: (
    state: ISearchState,
    payload: Error
  ): ISearchState => {
    return {
      ...state,
      history: {
        history: [],
        loading: false,
        error: payload
      }
    };
  },
};

const searchReducer = (
  state: ISearchState = getDefaultSearchState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) : state;
};

export default searchReducer;
